import { NgxMatColorPickerInput, Color } from "@angular-material-components/color-picker";
import { AfterViewInit, Component, Inject, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PreFilter, SubHeaders, US_ReportStandardLayout, US_ReportstandardType } from "../../api/models";
import { DialogResult, DialogResultType } from "../DialogResult";
import { MessageDialogComponent } from "../message-dialog/message-dialog.component";

export interface ReportStandardLayoutPropsDialogData {
  dialogTitle: string;
  reportStandardLayoutId: number;
  preFilterId?: number;
  subscriptionId?: number;
  name?: string;
  backgroundColor?: string;
  orderedPages?: string;
  headerFile: File;
  footerFile: File;
  headerImageUri?: string;
  footerImageUri?: string;
  clearHeader: boolean;
  clearFooter: boolean;

  reportStandardType: US_ReportstandardType;
  preFilters: PreFilter[];
}

@Component({
  selector: 'report-standard-layout-props-dialog',
  templateUrl: './report-standard-layout-props-dialog.component.html',
  styleUrls: ['./report-standard-layout-props-dialog.component.css']
})
export class ReportStandardLayoutPropsDialogComponent implements AfterViewInit {

  //@ViewChild(NgxMatColorPickerInput) pickerInput: NgxMatColorPickerInput;

  public Result: DialogResult;
  public reportPages: string[];
  public availablePages: string[];
  public layoutName: string = '<NEW LAYOUT>';
  public preFilters: PreFilter[] = [];
  public preFilterId: number = -1;
  public backgroundColor: string | undefined = undefined;
  public subscriptions: SubHeaders[];
  public subscriptionId: number = -1;
  public bgColor: Color = undefined;

  public clearHeader: boolean = false;
  public clearFooter: boolean = false;

  public selectedReportPage: string;

  headerFile: File | undefined = undefined;
  footerFile: File | undefined = undefined;

  headerImageSrc: string | undefined = undefined;
  footerImageSrc: string | undefined = undefined;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ReportStandardLayoutPropsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReportStandardLayoutPropsDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;

    this.availablePages = this.loadReportPages(this.data.reportStandardType.reportPages);
    this.reportPages = this.loadReportPages(this.data.orderedPages);
    this.subscriptions = this.data.reportStandardType.subscriptions;
    this.preFilters = this.data.preFilters;

    var tmpPages: string[] = [];

    for (var i = 0; i < this.availablePages.length; i++) {
      var target = this.reportPages.indexOf(this.availablePages[i]);
      if (target == -1)
        tmpPages.push(this.availablePages[i]);
    }

    this.availablePages = tmpPages;

    this.layoutName = this.data.name;
    this.preFilterId = this.data.preFilterId;
    this.subscriptionId = this.data.subscriptionId;

    if (this.subscriptionId === -1) {
      this.subscriptionId = this.subscriptions[0].subscriptionId;
    }

    this.headerFile = this.data.headerFile;
    this.footerFile = this.data.footerFile;

    if (this.data.headerImageUri) {
      this.headerImageSrc = this.data.headerImageUri;
    }

    if (this.data.footerImageUri) {
      this.footerImageSrc = this.data.footerImageUri;
    }

    this.backgroundColor = this.data.backgroundColor;
    if (this.backgroundColor && this.backgroundColor != '') {
      var tmp = this.hexToRgb(this.backgroundColor);
      this.bgColor = new Color(tmp.r, tmp.g, tmp.b);
    }
  }

  ngAfterViewInit(): void {
    /*this.pickerInput._valueChange.subscribe((newValue) => {
      this.backgroundColor = newValue.hex;
    });

    if (this.backgroundColor && this.backgroundColor != '') {
      const tmp = this.hexToRgb(this.backgroundColor);
      this.pickerInput.value = new Color(tmp.r, tmp.g, tmp.b);
    }*/
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    if (this.validateForm()) {
      this.data.name = this.layoutName;
      //this.data.backgroundColor = this.pickerInput.value?.hex;
      this.data.headerFile = this.headerFile;
      this.data.footerFile = this.footerFile;
      this.data.preFilterId = this.preFilterId;
      this.data.subscriptionId = this.subscriptionId;
      this.data.orderedPages = this.reportPages.join(",");
      this.data.headerImageUri = this.headerImageSrc;
      this.data.footerImageUri = this.footerImageSrc;
      this.data.clearHeader = this.clearHeader;
      this.data.clearFooter = this.clearFooter;

      this.Result.ResultType = DialogResultType.Ok;
      this.Result.ResultData = this.data;

      this.dialogRef.close(this.Result);
    }
  }

  readHeaderImage(files: FileList) {
    var srcFile = files.item(0);
    const reader = new FileReader();
    reader.onload = e => this.headerImageSrc = reader.result as string;
    reader.readAsDataURL(srcFile);

    this.headerFile = srcFile;
    this.clearHeader = false;
  }

  clearHeaderImage() {
    this.headerFile = undefined;
    this.headerImageSrc = undefined;
    this.clearHeader = true;
  }

  readFooterImage(files: FileList) {
    var srcFile = files.item(0);
    const reader = new FileReader();
    reader.onload = e => this.footerImageSrc = reader.result as string;
    reader.readAsDataURL(srcFile);

    this.footerFile = srcFile;
    this.clearFooter = false;
  }

  clearFooterImage() {
    this.footerFile = undefined;
    this.footerImageSrc = undefined;
    this.clearFooter = true;
  }

  loadReportPages(reportPagesString: string): string[] {
    if (reportPagesString == null || reportPagesString.length > 0) {
      return reportPagesString.split(",");
    }

    return [];
  }

  resetPages(): boolean {
    this.reportPages = this.loadReportPages(this.data.reportStandardType.reportPages);
    this.availablePages = [];

    return false;
  }

  addReportPage(): boolean {
    if (this.selectedReportPage && this.selectedReportPage != '') {
      this.reportPages.push(this.selectedReportPage);
      this.availablePages.splice(this.availablePages.indexOf(this.selectedReportPage), 1);
    }

    return false;
  }

  removeReportPage(reportPage: string): boolean {
    this.reportPages.splice(this.reportPages.indexOf(reportPage), 1);
    var basePages = this.loadReportPages(this.data.reportStandardType.reportPages);
    var resultPages: string[] = [];
    for (var i = 0; i < basePages.length; i++) {
      if (this.reportPages.indexOf(basePages[i]) == -1) {
        resultPages.push(basePages[i]);
      }
    }
    this.availablePages = resultPages;

    return false;
  }

  movePageUp(index: number): boolean {
    if (this.reportPages.length > 0 && index > 0 && index < this.reportPages.length) {
      var tmp = this.reportPages[index - 1];
      this.reportPages[index - 1] = this.reportPages[index];
      this.reportPages[index] = tmp;
    }

    return false;
  }

  movePageDown(index: number): boolean {
    if (this.reportPages.length > 0 && index >= 0 && index < (this.reportPages.length - 1)) {
      var tmp = this.reportPages[index + 1];
      this.reportPages[index + 1] = this.reportPages[index];
      this.reportPages[index] = tmp;
    }

    return false;
  }

  colorDisplay(): string {
    if (this.backgroundColor) {
      return "width: 100%; height: 30px; background-color:#" + this.backgroundColor;
    }
    return "";
  }

  hexToRgb(hex) {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, (m, r, g, b) => {
      return r + r + g + g + b + b;
    });
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  validateForm(): boolean {
    if (this.layoutName.trim() == '') return this.showValidationError("Layout name required");
    if (this.reportPages.length < 1) return this.showValidationError("At lease 1 report page is required");
    if (this.subscriptionId == -1) return this.showValidationError("Subscription selection required")
    return true;
  }

  showValidationError(errorMessage: string): boolean {
    MessageDialogComponent.showDialog(
      this.dialog,
      "Validation Error",
      errorMessage
    );

    return false;
  }

}
